/**
 *
 * Countries
 *
 */

import React, { useEffect, useState, useContext } from "react";
import { Spin, Tag, Table, Tooltip } from "antd";
import "./styles.css";
import Avatar from "../../components/avatar";
import svg from "../../utils/images/zobu.svg";
import logo from "../../utils/images/zostelLogo.svg";
import moment from "moment";
import Profile from "../profile";
import LeadContext from "../../contexts/leads";

export function LeadTable({ page }) {
  const [leads, setLeads] = useState({ leads: [] });
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [questions, setQuestions] = useState({ question: [] });
  const [lead, setLead] = useState({});
  const { supplyApi } = useContext(LeadContext);

  useEffect(() => {
    loadLeads();
    loadQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const loadLeads = () => {
    setLoading(true);
    supplyApi.get(`leads/?page=${page}&per_page=10`).then(async response => {
      setLeads({ leads: response.data.leads });
      setLoading(false);
    });
  };
  const loadQuestions = () => {
    setLoading(true);
    supplyApi.get("seed/").then(async response => {
      setQuestions({ question: response.data.questions });
      setLoading(false);
    });
  };

  if (loading) {
    return (
      <div style={{ height: 700, textAlign: "center", paddingTop: "30vh" }}>
        <Spin />
      </div>
    );
  }

  const showDrawer = e => {
    setLead(
      leads.leads.find(lead =>
        lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content === e.name
          : null
      )
    );
    setVisible(() => true);
  };

  if (leads.leads.length > 0) {
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 140,
        ellipsis: true,
        fixed: "left",
        render: text => {
          return (
            <p className="lead">
              <Avatar svg={svg} className="lead_avatar" />
              <span className="lead_name">{text}</span>
            </p>
          );
        }
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
        width: 200,
        ellipsis: true
      },
      {
        title: "Assets",
        key: "tags",
        dataIndex: "tags",
        width: 120,
        render: tags => (
          <span>
            {" "}
            {tags &&
              tags.map(tag => {
                if (tag === "Owns Property") {
                  return (
                    <Tooltip title="Owns Property">
                      <img
                        src={logo}
                        alt="property"
                        style={{ height: 20, width: 20, marginRight: 7 }}
                      />
                    </Tooltip>
                  );
                }
                if (tag === "NA") {
                  return (
                    <Tooltip title="Not Available">
                      <Tag color={"red"} key={tag}>
                        {tag}
                      </Tag>
                    </Tooltip>
                  );
                }
                return (
                  tag && (
                    <Tooltip title="Money(in lakhs)">
                      <Tag color={"green"} key={tag}>
                        {tag}
                      </Tag>
                    </Tooltip>
                  )
                );
              })}
          </span>
        )
      },
      {
        title: "Submitted",
        dataIndex: "submitted",
        key: "submitted",
        width: 100
      },
      {
        title: "Assigned To",
        key: "assigned",
        width: 100,
        dataIndex: "assigned",
        render: assigned => (
          <span>
            <a href="# " style={{ color: "#f05622" }}>
              {assigned ? assigned : "Unassigned"}
            </a>
          </span>
        )
      }
    ];

    const data = leads.leads.map(lead => {
      return {
        key: lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content
          : "NA",
        name: lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content
          : "NA",
        location: lead.answers.find(x => x.question === 3)
          ? lead.answers.find(x => x.question === 3).content
          : "NA",
        tags: [
          lead.answers.find(x => x.question === 20) ? "Owns Property" : "NA",
          lead.answers.find(x => x.question === 18)
            ? lead.answers.find(x => x.question === 18).content
            : "NA"
        ],
        submitted: moment
          .utc(lead.time_create)
          .local()
          .fromNow(),
        assinged: lead.assinged
      };
    });

    return (
      <>
        <Table
          columns={columns}
          dataSource={data}
          bordered
          pagination={false}
          style={{ marginTop: 10 }}
          scroll={{ x: 900, y: 2000 }}
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {
                showDrawer(record);
              }
            };
          }}
        />
        <Profile
          visible={visible}
          setVisible={setVisible}
          question={questions.question}
          lead={lead}
        />
      </>
    );
  }

  return null;
}

export default LeadTable;
